import { useTranslation } from 'react-i18next';
import { Button, Label, TableItem } from 'components/atoms';
import LabeledDeliveryStatus from 'components/molecules/labeledStatus/LabeledDeliveryStatus';
import { Table, TopBar } from 'components/organisms';
import { TopbarPage } from 'components/templates';
import toast from 'react-hot-toast';
import { PiNavigationArrow } from 'react-icons/pi';
import { useSearchParams } from 'react-router-dom';
import { useGetDigitalDeliveryErrorsDetails } from 'services/background-service-health';
import { IDigitalDeliveryErrorsDetails } from 'services/background-service-health/types';
import { DELIVERY_STATUS } from 'services/music-product-digital/types/enums';
import { magellanColumns } from 'types/components/table/table.types';

const DigitalDeliveryErrors = () => {
  const { t } = useTranslation();
  const [param] = useSearchParams();
  const statusId = parseInt(param.get('statusId') ?? '') as DELIVERY_STATUS;
  const deliveryErrorDetails = useGetDigitalDeliveryErrorsDetails({ statusId });

  const onClickToCopy = (title: string, value: string) => {
    toast.success(`${title} ${value} has been copied to clipboard!`);
    navigator.clipboard.writeText(value);
  };

  const goToProduct = (id: string) =>
    window.open(`/music-product-digital/${id}/delivery`, '_blank');

  return (
    <TopbarPage
      topbar={
        <TopBar
          title={`Delivery error details`}
          path='settings/logs'
          topbarContent={
            <div className='flex w-full'>
              <LabeledDeliveryStatus status={statusId} />
            </div>
          }
        />
      }>
      <Table
        loading={
          deliveryErrorDetails.isLoading ||
          deliveryErrorDetails.isFetchingNextPage
        }
        onFullyScroll={deliveryErrorDetails.fetchNextPage}
        size='compact'
        data={{
          nodes:
            deliveryErrorDetails.data?.pages
              .flat()
              .map(b => ({ ...b, id: b.digitalProductId })) ?? [],
        }}
        columns={magellanColumns<IDigitalDeliveryErrorsDetails & { id: string }>([
          {
            label: 'Errors',
            renderCell: ({ errorsCount }) => (
              <TableItem>
                {/* <TableItem.Text text={`${errorsCount}`} /> */}
                {/* <Button variant={BUTTON_VARIANT.remove} onlyIcon>
                  <Button.Text text={`${errorsCount}`} />
                </Button> */}
                <Label color='red' withText>
                  {/* <PiWarning />{' '} */}
                  <p className='font-black text-[16px]'>{errorsCount}</p>
                </Label>
              </TableItem>
            ),
            resize: true,
          },
          {
            label: 'Title',
            renderCell: ({ title, version }) => (
              <TableItem
                className='cursor-pointer'
                onClick={() => onClickToCopy('Title', title)}>
                <TableItem.Text text={title} />
                {version && <TableItem.Text isSupplementary text={version} />}
              </TableItem>
            ),
            resize: true,
          },
          {
            label: 'EAN',
            renderCell: ({ ean }) => (
              <TableItem
                className='cursor-pointer'
                onClick={() => onClickToCopy('Ean', ean)}>
                <TableItem.Text text={ean} />
              </TableItem>
            ),
            resize: true,
          },

          {
            label: '',
            minWidth: 56,
            renderCell: ({ digitalProductId }) => (
              <TableItem justifyPosition='end'>
                <Button
                  isClear
                  onlyIcon
                  onClick={() => goToProduct(digitalProductId)}>
                  <Button.Description description={t('button.open')} />


                  <Button.Icon
                    icon={<PiNavigationArrow transform='scale(-1,1)' />}
                  />
                </Button>
              </TableItem>
            ),
          },
        ])}
      />
    </TopbarPage>
  );
};

export default DigitalDeliveryErrors;
